export default {"src":"/planos/_next/static/media/equifax-company-size.57f33bed.svg","height":23,"width":26,"blurWidth":0,"blurHeight":0};